module.exports = __webpack_public_path__ + "static/media/amazone.f1bd75f3.gif";